<template src="./Hero.html"></template>
<style scoped src="./Hero.scss" lang="scss"></style>
<script>
const is = require("is_js");
import videojs from "video.js";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      activo: 0,
      videoIniciado: false,
      isPlayingVideo: false
    };
  },
  computed: {
    ...mapGetters([
      "header",
      "clientW",
      "clientIsMobile",
      "clientIsTouchDevice"
    ]),
    slides: function() {
      return this.$store.getters.header;
    },
    slideActivo: function() {
      return this.header.length > 0 ? this.header[this.activo] : {};
    }
  },
  watch: {
    slideActivo: function(newValue, oldValue) {
      if (newValue.urlVideo) this.updateVideoSrc();
    }
  },
  methods: {
    updateVideoSrc() {
      //si es móvil uso poster
      if (this.clientIsMobile)
        this.player.poster(this.slideActivo.posterVideoMobile);

      let sources;
      if (is.mobile()) {
        sources = [{ src: this.slideActivo.urlVideoMobile, type: "video/mp4" }];
      } else {
        sources = [{ src: this.slideActivo.urlVideo, type: "video/mp4" }];
      }

      this.player.src(sources);
    },
    toggleAudio() {
      this.player.muted(this.player.muted() ? false : true);
    },
    playVideo() {
      this.player.play();
      this.isPlayingVideo = true;
    },
    pauseVideoMobile() {
      if (!this.player.paused()) {
        this.player.pause();
        this.isPlayingVideo = false;
      }
    }
  },
  mounted() {
    let needAutoplay = !this.clientIsTouchDevice;

    this.player = videojs(
      this.$refs.videoPlayer,
      {
        controls: false,
        autoplay: needAutoplay,
        // muted: true,
        muted: needAutoplay,
        loop: true,
        playsinline: true
        // preload: "metadata",
      },
      function onPlayerReady() {}
    );

    this.videoIniciado = true;

    return false;
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
};
</script>
